<template>
    <div
        class="md-search md-search-grid-list template4"
        :class="{ [gridOrListType]: true }"
        v-if="listingSourceReady"
        :style="{ paddingTop, marginBottom }"
    >
        <component
            :is="mdSearchBar"
            ref="listingSearch"
            :searchBarOnly="false"
            v-show="showSearchBar"
            @conditionChange="conditionChange"
            :propsToData="dataToSearchBar"
        />
        <SearchResult
            cls="show-search mg-magtop-40 all-screen"
            :sortConfigs="sortConfigs"
            :hideBelow="hideBelow"
            :mapSearchText="mapSearchText"
            :mapDrawTip="mapDrawTip"
            :showSchool="showSchool"
            :propsToData="dataToSearchResult"
            ref="result"
        />
    </div>
</template>
<script>

import Core from '../index';
import searchBarMixin from '../../md-search-bar-mixin';
import { normal } from '../../defaultSpacing';
import { getAsyComponent } from '@/common/utils/load-module.js';
export default {
    data: function() {
        return {
            ...normal
        };
    },
    mixins: [Core, searchBarMixin('template4')],
    components: {
        SearchResult: getAsyComponent(() =>
            import(
                /*webpackChunkName: 'components/search-result/template4' */
                '../../../components/search-result/template4/index.vue'
            ))
    }
};
</script>
